<template>
  <v-btn
    dark
    color="#1a1a1f">
    <v-icon color="white">mdi-close-circle</v-icon>
  </v-btn>
</template>
